import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthBootScreen from './AuthBootScreen';

interface PrivateRouteProps {
  children: React.ReactNode;
}

/** Solo autentica. Los permisos por ruta se evalúan en Layout (alrededor del Outlet). */
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { authReady, isAuthenticated } = useAuth();

  if (!authReady) {
    return <AuthBootScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 